export default __webpack_public_path__ + "static/media/ベルモット.bd4461a3.PNG";